import { useQuery } from '@tanstack/react-query';

import { assetKeys } from '@/shared/lib/query/queryKeys';

import { fetchDatabaseSchemas } from '@/features/asset-detail/api/databaseSchemasApi';
import type { DatabaseSchemasResponse } from '@/features/asset-detail/api/databaseSchemasApi';

export const useDatabaseSchemas = (databaseFqn: string, includeDeleted: boolean = false, enabled: boolean = true) => {
  return useQuery<DatabaseSchemasResponse | null>({
    queryKey: assetKeys.databaseSchemas(databaseFqn, includeDeleted),
    queryFn: async () => {
      if (!enabled) {
        return null;
      }
      return fetchDatabaseSchemas(databaseFqn, { includeDeleted });
    },
    enabled: enabled && !!databaseFqn,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
};
